// maintenance.guard.ts
import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { maintenanceConfig } from '../../environments/environment.maintenance';
import { environment } from '../../environments/environment';

export const maintenanceGuard: CanMatchFn = (route, segments) => {
    const router = inject(Router);

    if (maintenanceConfig.isMaintenanceMode && !environment.preview) {

        const targetUrl = '/' + segments.map(s => s.path).join('/');

        if (!targetUrl.startsWith('/maintenance')) {
            return router.parseUrl('/maintenance');
        }
    }

    return true;
};
